import { render, staticRenderFns } from "./LabourRates.vue?vue&type=template&id=fa3aef02&"
import script from "./LabourRates.vue?vue&type=script&lang=js&"
export * from "./LabourRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports